import config from '../../../Config';
import * as serviceBase from './ServiceBase';
import { getPublicAccessToken, getFormattedUrl } from './utilities';


const API_BASE = config.devMode ? getFormattedUrl(config.formsApiBase) : '/TalentFormsApi/';
const LOG_CLIENT_MESSAGE = API_BASE + 'v1/logging/logClientMessage';

const FETCH_FORM_TEMPLATES = API_BASE + 'v1/companies/{companyId}/employees/{employeeId}/templates/formType/{formTypeId}/all?defaultTemplatesOnly={defaultTemplatesOnly}&sort=TemplateName';
const FETCH_MODULE_FORM_TEMPLATES = API_BASE + 'v1/modules/{moduleId}/templates/formType/{formTypeId}/all?defaultTemplatesOnly={defaultTemplatesOnly}&sort=TemplateName';
const GET_FORM_TEMPLATE = API_BASE + 'v1/companies/{companyId}/employees/{employeeId}/templates/{formTemplateId}/get';
const GET_FORM_TEMPLATE_BY_GUID = API_BASE + 'v1/companies/{companyId}/employees/{employeeId}/templates/{formTemplateGuid}/getByGuid';
const SAVE_FORM_TEMPLATE = API_BASE + 'v1/companies/{companyId}/employees/{employeeId}/templates/upsert';
const DELETE_FORM_TEMPLATE = API_BASE + 'v1/companies/{companyId}/employees/{employeeId}/templates/delete';
const LAUNCH_FORM_INSTANCE = API_BASE + 'v1/companies/{companyId}/employees/{employeeId}/formInstance/launchForm';
const GET_FORM_INSTANCE = API_BASE + 'v1/companies/{companyId}/employees/{employeeId}/formInstance/{formInstanceId}/get?includeParticipants={includeParticipants}';
const GET_FORM_INSTANCE_WITH_CONFIDENTIALITY = API_BASE + 'v1/companies/{companyId}/employees/{employeeId}/formInstance/{formInstanceId}/getWithConfidentiality?includeParticipants={includeParticipants}&viewConfidentially={viewConfidentially}';
const GET_FORM_INSTANCE_PARTICIPANT = API_BASE + 'v1/companies/{companyId}/employees/{employeeId}/formInstanceParticipant/{formInstanceParticipantGuid}/get';
const GET_MODULE_FORM_INSTANCE_PARTICIPANT = API_BASE + 'v1/modules/{moduleId}/employees/{employeeId}/formInstanceParticipant/{formInstanceParticipantGuid}/get';
const GET_FORM_INSTANCE_PARTICIPANT_BY_INSTANCE = API_BASE + 'v1/companies/{companyId}/employees/{employeeId}/formInstanceParticipant/{formInstanceGuid}/getByInstance';
const GET_FORM_INSTANCE_PARTICIPANT_BY_FOREIGNID = API_BASE + 'v1/companies/{companyId}/employees/{employeeId}/formType/{formTypeId}/formInstanceParticipant/foreignId/{foreignId}/get';
const SAVE_FORM_INSTANCE_PARTICIPANT = API_BASE + 'v1/companies/{companyId}/employees/{employeeId}/formInstanceParticipant/update';
const DECLINE_FORM_INSTANCE_PARTICIPANT = API_BASE + 'v1/companies/{companyId}/employees/{employeeId}/formInstanceParticipant/{formInstanceParticipantGuid}/decline';
const GET_QUESTION_BANK_QUESTIONS = API_BASE + 'v1/questionbank/formType/{formTypeId}/all';

const PUBLIC_API_BASE = config.devMode ? getFormattedUrl(config.publicFormsApiBase) : getFormattedUrl(window.pctytalentformsexternalgatewaybaseurl) + 'public/';
const PUBLIC_GET_FORM_INSTANCE_PARTICIPANT = PUBLIC_API_BASE + 'v1/public/companies/{companyId}/formInstanceParticipant/{formInstanceParticipantGuid}/get?publicAccessToken={publicAccessToken}';
const PUBLIC_GET_FORM_INSTANCE_PARTICIPANT_BY_INSTANCE = PUBLIC_API_BASE + 'v1/public/companies/{companyId}/formInstanceParticipant/{formInstanceGuid}/getByInstance?publicAccessToken={publicAccessToken}';
const PUBLIC_SAVE_FORM_INSTANCE_PARTICIPANT = PUBLIC_API_BASE + 'v1/public/companies/{companyId}/formInstanceParticipant/update?publicAccessToken={publicAccessToken}';
const PUBLIC_DECLINE_FORM_INSTANCE_PARTICIPANT = PUBLIC_API_BASE + 'v1/public/companies/{companyId}/formInstanceParticipant/{formInstanceParticipantGuid}/decline?publicAccessToken={publicAccessToken}';


export async function getFormTemplate(companyId, employeeId, formTemplateId) {
  // check if the formTemplateId is an int; otherwise it's a guid
  if (formTemplateId && formTemplateId.toString().length < 12 && parseInt(formTemplateId)) {
    return await serviceBase.get(GET_FORM_TEMPLATE, { companyId, employeeId, formTemplateId });
  }
  else {
    let formTemplateGuid = formTemplateId;
    return await serviceBase.get(GET_FORM_TEMPLATE_BY_GUID, { companyId, employeeId, formTemplateGuid });
  }
}

export async function getFormTemplates(companyId, employeeId, formTypeId, defaultTemplatesOnly = false) {
  return await serviceBase.get(FETCH_FORM_TEMPLATES, { companyId, employeeId, formTypeId, defaultTemplatesOnly });
}

export async function getModuleFormTemplates(moduleId, formTypeId, defaultTemplatesOnly = false) {
  return await serviceBase.get(FETCH_MODULE_FORM_TEMPLATES, { moduleId, formTypeId, defaultTemplatesOnly });
}

export async function saveFormTemplate(companyId, employeeId, formTemplate) {
  return await serviceBase.post(SAVE_FORM_TEMPLATE, { companyId, employeeId }, formTemplate);
}

export async function deleteFormTemplate(companyId, employeeId, formTemplateId) {
  return await serviceBase.post(DELETE_FORM_TEMPLATE, { companyId, employeeId, formTemplateId });
}

export async function launchFormInstance(companyId, employeeId, formInstance) {
  return await serviceBase.post(LAUNCH_FORM_INSTANCE, { companyId, employeeId }, formInstance);
}

export async function getFormInstance(companyId, employeeId, formInstanceId, includeParticipants) {
  return await serviceBase.get(GET_FORM_INSTANCE, { companyId, employeeId, formInstanceId, includeParticipants });
}

export async function getFormInstanceWithConfidentiality(companyId, employeeId, formInstanceId, includeParticipants, viewConfidentially) {
  return await serviceBase.get(GET_FORM_INSTANCE_WITH_CONFIDENTIALITY, { companyId, employeeId, formInstanceId, includeParticipants, viewConfidentially });
}

export async function getFormInstanceParticipant(companyId, employeeId, formInstanceParticipantGuid, isPublicForm, moduleId) {
  if (isPublicForm) {
    let publicAccessToken = getPublicAccessToken(companyId, formInstanceParticipantGuid);
    return await serviceBase.get(PUBLIC_GET_FORM_INSTANCE_PARTICIPANT, { publicAccessToken, companyId, formInstanceParticipantGuid }, !config.devMode==true, undefined, true);
  }
  else {
    return moduleId ? await serviceBase.get(GET_MODULE_FORM_INSTANCE_PARTICIPANT, { moduleId, employeeId, formInstanceParticipantGuid })
      : await serviceBase.get(GET_FORM_INSTANCE_PARTICIPANT, { companyId, employeeId, formInstanceParticipantGuid });
  }
}

export async function getFormInstanceParticipantByInstance(companyId, employeeId, formInstanceGuid, isPublicForm) {
  if (isPublicForm) {
    let publicAccessToken = getPublicAccessToken(companyId, formInstanceGuid);
    return await serviceBase.get(PUBLIC_GET_FORM_INSTANCE_PARTICIPANT_BY_INSTANCE, { publicAccessToken, companyId, formInstanceGuid }, !config.devMode==true, undefined, true);
  }
  else {
    return await serviceBase.get(GET_FORM_INSTANCE_PARTICIPANT_BY_INSTANCE, { companyId, employeeId, formInstanceGuid });
  }
}

export async function getFormInstanceParticipantByForeignId(companyId, employeeId, formTypeId, foreignId) {
  return await serviceBase.get(GET_FORM_INSTANCE_PARTICIPANT_BY_FOREIGNID, { companyId, employeeId, formTypeId, foreignId });
}

export async function saveFormInstanceParticipant(companyId, employeeId, formInstanceParticipant, isPublicForm) {
  if (isPublicForm) {
    let publicAccessToken = getPublicAccessToken(companyId, formInstanceParticipant.formInstanceParticipantGuid);
    return await serviceBase.post(PUBLIC_SAVE_FORM_INSTANCE_PARTICIPANT, { publicAccessToken, companyId }, formInstanceParticipant, !config.devMode==true, true);
  }
  else {
    return await serviceBase.post(SAVE_FORM_INSTANCE_PARTICIPANT, { companyId, employeeId }, formInstanceParticipant);
  }
}

export async function declineFormInstanceParticipant(companyId, employeeId, formInstanceParticipantGuid, formInstance, isPublicForm) {
  if (isPublicForm) {
    let publicAccessToken = getPublicAccessToken(companyId, formInstanceParticipantGuid);
    return await serviceBase.post(PUBLIC_DECLINE_FORM_INSTANCE_PARTICIPANT, { publicAccessToken, companyId, formInstanceParticipantGuid }, formInstance, config.devMode==true, true);
  }
  else {
    return await serviceBase.post(DECLINE_FORM_INSTANCE_PARTICIPANT, { companyId, employeeId, formInstanceParticipantGuid }, formInstance);
  }
}

export async function logClientMessage(message, clientUrl, lineNumber, isError) {
  let clientLogInfo = {message, clientUrl, lineNumber, isError};
  return await serviceBase.post(LOG_CLIENT_MESSAGE, {}, clientLogInfo);
}

export async function getQuestionBank(formTypeId) {
  return await serviceBase.get(GET_QUESTION_BANK_QUESTIONS, { formTypeId });
}
